//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { KinesisContainer, KinesisElement } from "vue-kinesis";
import mainSlider from "~/components/main-slider";
import MainSliderV2 from "~/components/main-slider-v2.vue";
import SocialShareBtns from "~/components/social-share-btns";

export default {
  data() {
    return {};
  },
  async asyncData({ store }) {
    await store.dispatch("others/getCareerPage");
    const pageData = store.state["others"].career;
    return { pageData };
  },
  head() {
    return {
      title: this.pageData[0].page.seo.meta_title,
      meta: [
        {
          name: "description",
          hid: "description",
          content: this.pageData[0].page.seo.meta_description,
        },
        {
          name: "og:description",
          hid: "og:description",
          content: this.pageData[0].page.seo.meta_description,
        },
        {
          name: "keywords",
          hid: "keywords",
          content: this.pageData[0].page.seo.keywords,
        },
        {
          property: "og:url",
          content: `https://www.dilmahtea.com${this.$route.path}`,
        },

        {
          property: "og:image",
          hid: "og:image",
          content: this.pageData[0].page.seo.share_image_url,
        },
        {
          property: "og:title",
          hid: "og:title",
          content: this.pageData[0].page.seo.meta_title,
        },
        {
          property: "og:image:alt",
          hid: "og:image:alt",
          content: this.pageData[0].page.seo.share_image_alt,
        },

        {
          name: "shareImageAlt",
          hid: "shareImage",
          content: this.pageData[0].page.seo.share_image_alt,
        },
        {
          name: "shareImage",
          hid: "shareImage",
          content: this.pageData[0].page.seo.share_image_url,
        },
        {
          name: "preventindex",
          hid: "preventindex",
          content: this.pageData[0].page.seo.prevent_indexing,
        },
      ],
    };
  },

  components: {
    mainSlider,
    MainSliderV2,
    KinesisContainer,
    KinesisElement,
    SocialShareBtns,
  },

  computed: {
    sliderMedia() {
      return this.pageData[0].page.sliders.map((item) => ({
        type: item.slider_has_video ? "VID" : "IMG",
        url: item.slider_has_video ? item.video_url : item.image_url,
      }));
    },
  },
};
